import { ActionContext } from 'vuex';
import { CipCodeSprache } from '../generated/dto/dto-typings';
import {
    ConstructionProjectEnum,
    ConstructionTypeEnum,
    OfferingLevelEnum,

} from '../domain/webservice-dto';
import { Construction, SalutationEnum } from '@/app/domain/constructionStoreInterface';

export enum ConstructionStoreGetters {
    ConstructionFormIsDirty = 'ConstructionFormIsDirty',
    ConstructionFormIsSubmitting = 'ConstructionFormIsSubmitting',
    ConstructionTypes = 'ConstructionTypes',
    ConstructionType = 'ConstructionType',
    ConstructionProject = 'ConstructionProject',
    ConstructionLocation = 'ConstructionLocation',
    ConstructionRisks = 'ConstructionRisks',
    ConstructionDuration = 'ConstructionDuration',
    ConstructionSum = 'ConstructionSum',
    ConstructionMatrix = 'ConstructionMatrix',
    ConstructionContact = 'ConstructionContact',
    ConstructionAdvisor = 'ConstructionAdvisor',
    ConstructionShareLink = 'ConstructionShareLink',
    Construction = 'Construction',
    QuoteId = 'QuoteId',
}

export enum ConstructionStoreActions {
    ResetStore = 'ResetStore',
    SaveConstructionFormIsDirty = 'SaveConstructionFormIsDirty',
    SaveConstructionAdvisor = 'SaveConstructionAdvisor',
    SaveConstructionFormIsSubmitting = 'SaveConstructionFormIsSubmitting',
    SaveConstructionLocation = 'SaveConstructionLocation',
    SaveConstructionRisks = 'SaveConstructionRisks',
    SaveConstructionDuration = 'SaveConstructionDuration',
    SaveConstructionSum = 'SaveConstructionSum',
    SaveConstructionMatrix = 'SaveConstructionMatrix',
    SaveConstructionContact = 'SaveConstructionContact',
    SaveConstructionLanguage = 'SaveConstructionLanguage',
    SaveConstruction = 'SaveConstruction',
    SaveConstructionType = 'SaveConstructionType',
    SaveConstructionProject = 'SaveConstructionProject',
    SaveConstructionOverviewLink = 'SaveConstructionOverviewLink',
    SaveConstructionShareLink = 'SaveConstructionShareLink',
    SaveQuoteId = 'QuoteId',
}

export interface ConstructionStoreState {
    isDirty: boolean;
    isSubmitting: boolean;
    shareLink: string;
    data: Construction;
}

export type ConstructionActionContext = ActionContext<ConstructionStoreState, ConstructionStoreState>;

export interface ConstructionTypes {
    constructionProject?: ConstructionProjectEnum;
    constructionType?: ConstructionTypeEnum;
}

export interface ConstructionLocation {
    postcode?: string;
    city?: string;
    canton?: string;
    street?: string;
}

export interface ConstructionRisks {
    newConstruction?: boolean;
    modificationLoadBearingParts?: boolean;
    buildingOnRock?: boolean;
    loweringGroundWater?: boolean;
    pileDrivingElements?: boolean;
    undertakingBuilding?: boolean;
    constructionInDangerZone?: boolean;
}

export interface ConstructionSum {
    constructionSum: number;
}

export interface ConstructionDuration {
    duration?: number;
    startDate?: Date;
    completionDate?: Date;
}

export interface ConstructionContact {
    salutation?: SalutationEnum;
    postcode?: string;
    city?: string;
    street?: string;
    canton?: string;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: Date;
    email?: string;
    phone?: string;
    companyName?: string;
    languageOfCorrespondence?: CipCodeSprache;
}

export interface ConstructionMatrix {
    offeringLevel?: OfferingLevelEnum;
}

export interface ConstructionAdvisor {
    advisorText?: string;
    advisorMail?: string;
}
